import { v7 as uuidv7 } from 'uuid';

/** UUIDv7: time-ordered, collision-free, assigned at creation (§3.3). */
export const newId = (): string => uuidv7();

export const nowIso = (): string => new Date().toISOString();
